import EmberRouter from '@ember/routing/router'
import config from 'customer-flows/config/environment'
import Logger from 'customer-flows/utils/logger'

// This variable can be used as a place to update with a JS change whenever we have CSS/templtate only changes to invalidate the Fastly cache and prevent a caching fire
const appVersion = '1.0.4'

// used by FlowPage util to map page types to route names
export const routeMap: { [T in PageType]: string } = {
  FlowConfigBookingStartPage: 'flow.booking.start',
  FlowConfigBookingUpsellsPage: 'flow.booking.upsells',
  FlowConfigBookingInfoPage: 'flow.booking.info',
  FlowConfigBookingPaymentPage: 'flow.booking.payment',
  FlowConfigBookingConfirmationPage: 'flow.booking.confirmation',
  FlowConfigTilesPage: 'flow.tiles',
  FlowConfigBookingExtensionPage: 'flow.booking.extension'
}

export default class Router extends EmberRouter {
  constructor() {
    super(...arguments)
    this.rootURL = config.rootURL
    this.location = config.locationType

    if (window !== window.top) {
      this.location = 'hash'
    }

    Logger.debug('App initialized', { appVersion }) // shuts up the ts error in the console lol
  }
}

Router.map(function () {
  // rootUrl is '/w/' so all routes are relative to that
  this.route('flow', { path: '/:key/:program_id' }, function () {
    this.route('booking', { path: '/b' }, function () {
      this.route('start')
      this.route('upsells')
      this.route('info')
      this.route('payment')
      this.route('confirmation')

      this.route('extension', { path: 'e/:page_name' })
      this.route('not-found', { path: '/*path' })
    })
    this.route('tiles', { path: '/t' })
  })
})
